
import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

function MapaSitio() {
    return (
        <>
            <div className="main" style={{ marginTop: "10em" }}>
                <div id="servicio" style={{ backgroundColor: "#f9f9f9" }}>
                    <Container className="fluid">
                        <Row className="justify-content-center">
                            <Col lg="12">
                                <h1 className="text-center title" style={{ color: "#031425" }}>
                                    MAPA DEL SITIO<br />
                                </h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <Card>
                                    <CardBody>
                                        <h3><b style={{ color: "#080f61" }}>Posts por categoría</b></h3>
                                        <ul>
                                            <li>
                                                <a href="/transparencia">Normativa</a>
                                                <ul>
                                                    <li><a href="/Normativa">Normativa</a></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/transparencia">Informes a organismos de inspección, vigilancia y control</a>
                                                <ul>
                                                    <li><a href="/transparencia">Informes a organismos de inspección, vigilancia y control</a></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/transparencia">Planes de mejoramiento</a>
                                                <ul>
                                                    <li><a href="/transparencia">Planes de Mejoramiento vigentes exigidos por los entes de control o auditoría externos o internos</a></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/transparencia/informesGestion">Informes de gestión, evaluación y auditoría</a>
                                                <ul>
                                                    <li><a href="/InfoTramites">Formatos y/o formularios asociados</a></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/GestionInformacion">Instrumentos de gestión de la información</a>
                                                <ul>
                                                    <li><a href="/GestionInformacion">Instrumentos de gestión de la información</a></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/ClasificadaReservada">Índice de información clasificada y reservada</a>
                                                <ul>
                                                    <li><a href="/ClasificadaReservada">Índice de información clasificada y reservada</a></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/GestionDocumental">Programa de gestión documental</a>
                                                <ul>
                                                    <li><a href="/GestionDocumental">Programa de gestión documental</a></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/RetencionDocumental">Tablas de retención documental</a>
                                                <ul>
                                                    <li><a href="/RetencionDocumental">Tablas de retención documental</a></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/transparencia/informacionJovenes">Información para niños, niñas y adolescentes</a>
                                                <ul>
                                                    <li><a href="/transparencia/informacionJovenes">Información para niños, niñas y adolescentes</a></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/Mujeres">Información para Mujeres</a>
                                                <ul>
                                                    <li><a href="/Mujeres">Información para Mujeres</a></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    );
}

export default MapaSitio;